<template>
  <el-aside width="60px"
            @mouseenter.native="toggleSide(true)"
            @mouseleave.native="toggleSide(false)"
            class="the-sidebar"
            :class="toggle ? 'expand-side' : ''">
    <transition-group name="fade-items"
                      tag="ul"
                      class="menu"
                      @before-enter="fadeIn" @enter="fadeOut">
      <template v-for="item in menu">
        <template v-if="item.children">
          <li :key="item.index"
              :index="item.index"
              :data-index="item.index"
              @click="collapse(item.index)">
            <span class="item"
                  :class="item.children.map(i => i.index)
                  .indexOf(active) !== -1 ? 'item-active' : ''">
              <i :class="item.icon"/>{{item.title}}<i class="el-icon-arrow-down"/>
            </span>
            <transition name="collapse-menu"
                        :key="item.index"
                        @before-enter="beIn" @enter="beOut"
                        @before-leave="beOut" @leave="beIn">
              <ul v-show="showSubMenu === item.index"
                  class="sub-menu">
                <li v-for="subItem in item.children"
                    :key="subItem.index"
                    :index="subItem.index"
                    @click="goTo(subItem.route, subItem.index)"
                    class="sub-item"
                    :class="active === subItem.index ? 'item-active' : ''">
                  {{subItem.title}}
                </li>
              </ul>
            </transition>
          </li>
        </template>
        <li v-else
            :key="item.index"
            :index="item.index"
            :data-index="item.index"
            @click="goTo(item.route, item.index)"
            class="item"
            :class="active === item.index ? 'item-active' : ''">
          <i :class="item.icon"/>{{item.title}}
        </li>
      </template>
    </transition-group>
  </el-aside>
</template>

<script>
import sideMenu from '../../mixins/sideMenu';

export default {
  name: 'TheSidebar',
  data() {
    return {
      menu: [],
      active: '',
      toggle: false,
      showSubMenu: '',
    };
  },
  mounted() {
    sideMenu().then((menus) => {
      this.menu = menus;
      this.setActive();
    });
  },
  watch: {
    $route() {
      this.setActive();
    },
  },
  methods: {
    toggleSide(e) {
      if (!e) this.showSubMenu = null;
      this.toggle = e;
      // this.toggle = true;
    },
    collapse(act) {
      this.showSubMenu = this.showSubMenu === act ? '' : act;
    },
    beIn(el) {
      // eslint-disable-next-line no-param-reassign
      el.style.height = '0';
    },
    beOut(el) {
      // eslint-disable-next-line no-param-reassign
      el.style.height = `${el.scrollHeight}px`;
    },
    fadeIn(el) {
      // eslint-disable-next-line no-param-reassign
      el.style.opacity = 0;
    },
    fadeOut(el) {
      const delay = el.dataset.index * 80;
      setTimeout(() => {
        // eslint-disable-next-line no-param-reassign
        el.style.opacity = 1;
      }, delay);
    },
    goTo(name, index) {
      if (this.$route.name !== name) {
        this.$router.replace({ name });
        this.active = index;
      }
    },
    setActive() {
      const active = this.menu.slice().reduce((acc, el) => {
        // eslint-disable-next-line no-param-reassign
        if (el.children) acc = acc.concat(el.children);
        if (el.route) acc.push(el);
        return acc;
      }, []).find(m => m.route === this.$route.name);
      this.active = active !== undefined ? active.index : '';
    },
  },
};
</script>

<style lang="scss" scoped>
  .the-sidebar {
    font-weight: 600;
    color: $fb-grey-light-10;
    overflow-x: hidden;
    position: absolute;
    letter-spacing: 0.3px;
    z-index: 11 !important;
    background-color: white;
    height: calc(100vh - 50px);
    transition: width 0.15s ease;
    box-shadow: 3px 0 10px 0 rgba(74, 74, 74, 0.15);
    .menu {
      width: 260px;
      margin: 50px 0 0 0;
      .item, .sub-item {
        height: 23px;
        line-height: 2;
        display: block;
        cursor: pointer;
        user-select: none;
        padding: 10px 7px;
        position: relative;
        border-left: 4px solid white;
        .fas {
          width: 36px;
          font-size: 18px;
          text-align: center;
          vertical-align: sub;
        }
        .el-icon-arrow-down {
          float: right;
          font-weight: 900;
        }
        .fas, .el-icon-arrow-down { margin-right: 13px; }
      }
      .item:hover, .sub-item:hover {
        color: white !important;
        .fas { color: white !important; }
        background-color: $fb-green !important;
        border-left: 4px solid $fb-green !important;
      }
      .sub-menu {
        overflow: hidden;
        background-color: $fb-grey-light-97;
        border-top: 1px solid $fb-grey-light-92;
        border-bottom: 1px solid $fb-grey-light-92;
        .sub-item { padding-left: 24px; }
        box-shadow: rgba(224, 224, 224, 0.2) 3px 3px 4px 0 inset,
        rgb(224, 224, 224, 0.2) 0px -5px 6px -4px inset;
      }
    }
    .menu, .sub-menu { padding: 0; }
  }
  .collapse-menu-enter-active, .collapse-menu-leave-active { transition: all 0.2s ease; }
  .fade-items-enter-active, .fade-items-leave-active { transition: all 0.8s ease; }
  .expand-side {
    width: 260px !important;
    transition: width 0.15s ease 0.2s;
  }
  .item-active {
    color: $fb-green-dark-10;
    .fas { color: $fb-green; }
    background-color: $fb-green-light-90;
    border-left: 4px solid $fb-green !important;
  }
</style>
